/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { accountState } from "./account.state";


const accountSlice = createSlice({
    name: "account",

    initialState: accountState,

    reducers: {
        setAccountItem (state, action) {
            const account = action.payload;
            let guid;
            if (account) {
                guid = account.guid;
            }
            state.current = account;
            state.current_guid = guid;
        },

        removeAccountItem (state) {
            state.current = undefined;
            state.current_guid = undefined;
        },
        
        setUserRoles (state, action) {
            const roles = action.payload;
            if (Array.isArray(roles)) {
                state.roles = roles;
            }
        },
        
        removeUserRoles (state) {
            state.roles = undefined;
        },
        
    },
});

export const accountReducer = accountSlice.reducer;

export const {
    setAccountItem,
    removeAccountItem,
    setUserRoles,
    removeUserRoles
} = accountSlice.actions;
